import React from 'react';
import Orders from './Orders';

function OrdersOutForDelivery() {
  return <Orders status="out-for-delivery" />;
}

export default OrdersOutForDelivery;
